import React from "react";

const getTextClass = (index, mode, bigHeader) => {
  if (mode === "h2") return index === 1 ? "header-text-accent" : "";
  if (index === 1) return bigHeader ? "header-text header-text-accent" : "accent-heading-text";
  return bigHeader ? "header-text" : "regular-heading-text";
};

function XoiComHeading({ heading, textColor, bigHeader, mode }) {
  const text = heading.split("::").map((t, index) => (
    <span key={index} className={getTextClass(index, mode, bigHeader)}>
      {t}{" "}
    </span>
  ));

  return (
    <div style={{ color: textColor ? textColor : "black" }}>
      {mode === "h2" ? <h2>{text}</h2> : <div>{text}</div>}
    </div>
  );
}

export default XoiComHeading;
